module.exports = __webpack_public_path__ + "img/undoButtonOff.215e7345.svg";